import { PropsWithChildren } from "react";
import Button, { ButtonProps, IconButton } from "domains/ui/components/Button";
import Icon from "domains/ui/components/Icon";

import { HStack, Text } from "@chakra-ui/react";

interface BreadcrumbProps extends PropsWithChildren {
  onBack: () => void;
}

export function Breadcrumb({ children, onBack }: BreadcrumbProps) {
  return (
    <HStack spacing={4}>
      <IconButton
        aria-label="back"
        variant="secondary"
        onClick={onBack}
        size="xs"
      >
        <Icon id="Ui/ChevronLeft" />
      </IconButton>

      {children}
    </HStack>
  );
}

// ------------------------------------

interface BreadcrumbItemProps extends Omit<ButtonProps, "isDisabled"> {
  isDisabled?: boolean;
}

export function BreadcrumbItem({ isDisabled, ...props }: BreadcrumbItemProps) {
  return (
    <Button
      size="sm"
      variant="link"
      colorScheme="white"
      _hover={{
        color: "textPrimary",
      }}
      pointerEvents={isDisabled ? "none" : undefined}
      {...props}
    />
  );
}

// ------------------------------------

export function BreadcrumbDivider() {
  return (
    <Text color="textTertiary" size="body.xs">
      /
    </Text>
  );
}
